var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyPreidctionReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6247 5.40625H2.48249L7.95437 0.65625C8.04187 0.579688 7.98874 0.4375 7.87312 0.4375H6.4903C6.42937 0.4375 6.37155 0.459375 6.32624 0.498437L0.421554 5.62188C0.367474 5.66875 0.324102 5.72671 0.294377 5.79181C0.264651 5.85692 0.249268 5.92765 0.249268 5.99922C0.249268 6.07079 0.264651 6.14152 0.294377 6.20663C0.324102 6.27173 0.367474 6.32969 0.421554 6.37656L6.36062 11.5313C6.38405 11.5516 6.41218 11.5625 6.44187 11.5625H7.87155C7.98718 11.5625 8.0403 11.4188 7.9528 11.3438L2.48249 6.59375H11.6247C11.6934 6.59375 11.7497 6.5375 11.7497 6.46875V5.53125C11.7497 5.4625 11.6934 5.40625 11.6247 5.40625Z",
    fill: "current",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyPreidctionReturn);
export default __webpack_public_path__ + "static/media/weekly-preidction-return.86c887591b1989f77d0cbddb9b3a052a.svg";
export { ForwardRef as ReactComponent };